import { QuestionCategory } from "winslow-core";

export const CATEGORY_COLORS = [
  {
    backgroundColor: "#3366CC", // Distinct Blue
    borderColor: "transparent",
  },
  {
    backgroundColor: "#DC3912", // Bright Red
    borderColor: "rgba(75,192,192,1)",
  },
  {
    backgroundColor: "#FF9900", // Vivid Orange
    borderColor: "rgba(75,192,192,1)",
  },
  {
    backgroundColor: "#109618", // Strong Green
    borderColor: "rgba(75,192,192,1)",
  },
  {
    backgroundColor: "#990099", // Deep Purple
    borderColor: "rgba(75,192,192,1)",
  },
  {
    backgroundColor: "#3B3EAC", // Blue-Violet
    borderColor: "transparent",
  },
  {
    backgroundColor: "#0099C6", // Teal
    borderColor: "rgba(75,192,192,1)",
  },
  {
    backgroundColor: "#DD4477", // Magenta-ish
    borderColor: "rgba(75,192,192,1)",
  },
  {
    backgroundColor: "#66AA00", // Lime Green
    borderColor: "rgba(75,192,192,1)",
  },
  {
    backgroundColor: "#AAAA11", // Mustard
    borderColor: "rgba(75,192,192,1)",
  },
];
const categoryKeys = Object.values(QuestionCategory);

const categoryColorMap = new Map<
  string,
  { backgroundColor: string; borderColor: string }
>();

categoryKeys.forEach((category, index) => {
  const color = CATEGORY_COLORS[index % CATEGORY_COLORS.length];
  categoryColorMap.set(category, color);
});

export const getCategoryColor = (category: string): string => {
  const record = categoryColorMap.get(category) || {
    backgroundColor: "#4ECDC4",
    borderColor: "transparent",
  };
  return record.backgroundColor;
};
